export default __webpack_public_path__ + "static/media/refresh.bd687146.svg";